import allisonHeadshot from '@/../public/_n/images/second-free-trial/Testimonial-Allison.png';
import celesteHeadshot from '@/../public/_n/images/second-free-trial/Testimonial-Celeste.png';
import johnHeadshot from '@/../public/_n/images/second-free-trial/Testimonial-John.png';

import messages from '../messages';
import { Stat } from './types';

const validationCards: Record<string, Stat> = {
	reportedLessAnxiety: {
		stat: messages.validationStat1,
		quote: messages.validationQuote1,
		quoteDescription: messages.validationQuote1Description,
		quoteName: messages.validationQuote1Name,
		quotePhoto: celesteHeadshot,
	},
	expressedHigherQualitySleep: {
		stat: messages.validationStat2,
		quote: messages.validationQuote2,
		quoteDescription: messages.validationQuote2Description,
		quoteName: messages.validationQuote2Name,
		quotePhoto: johnHeadshot,
	},
	reportedImprovedMentalHealth: {
		stat: messages.validationStat3,
		quote: messages.validationQuote3,
		quoteDescription: messages.validationQuote3Description,
		quoteName: messages.validationQuote3Name,
		quotePhoto: allisonHeadshot,
	},
} as const;

export default validationCards;
